<template>
    <div v-if="hasErrors" class="rounded-md bg-red-50 p-4 mt-5">
        <div class="flex">
            <div class="shrink-0">
                <svg aria-hidden="true" class="h-5 w-5 text-red-400" fill="currentColor"
                     viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          fill-rule="evenodd"/>
                </svg>
            </div>
            <div class="ml-3">
                <div v-if="(responseStatus?.errors?.length ?? 0) > 0">
                    <h3 class="text-sm font-medium text-red-800">{{computedTitle}}</h3>
                    <div class="mt-2 text-sm text-red-700">
                        <ul id="errors" class="card-text">
                            <li v-for="error in responseStatus?.errors" v-html="error.message"></li>
                        </ul>
                    </div>
                </div>
                <div v-else>
                    <h3 class="text-sm font-medium text-red-800" v-html="responseStatus?.message"></h3>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps } from "vue";
import {ResponseStatus} from "@servicestack/client";

const props = defineProps<{
    responseStatus: ResponseStatus | null,
    title?: string,
}>();

const computedTitle = computed(() => props.title ?? "Oops. Fix the errors below and try again.");

const hasErrors = computed(() => {
    if(props.responseStatus){
        if(props.responseStatus.errors?.length > 0 
            || props.responseStatus.errorCode?.length > 0
            || props.responseStatus.message?.length > 0)
            return true;
    }
    return false;
});
</script>